
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "types",
  setup(props, ctx) {
    const values = ref(ctx.attrs.modelValue || 0);
    const types = ref([
      {
        label: "crypto",
        value: 0,
        show: ctx.attrs.showCrypto
      },
      {
        label: "fiat",
        value: 1,
        show: ctx.attrs.showFiat
      }
    ]);

    const changeMethod = (val: Number) => {
      values.value = val;
      ctx.emit("update:modelValue", val);
    };

    return {
      values,
      types,
      changeMethod
    };
  }
});
